import { atom } from 'jotai';


export const cartAtom = atom<Product[]>([]);
